<template>
<article class="no-box">
  <section class="he-ad flex">
    <strong class="ml-20">{{title}}{{$t('权限列表')}}</strong>

    <div class="ac-btn">
      <el-button type="info" @click="handleExpandClick">{{$t('全部展开')}}</el-button>
      <el-button type="danger" @click="handleClearClick">{{$t('清空选择')}}</el-button>
      <el-button type="primary" @click="handleAllClick">{{$t('全选')}}</el-button>
    </div>
  </section>

  <section class="tr-ee" v-if="permissionsData.length">
    <PermissionNode v-for="i in permissionsData" :key="i.resourceId" :node="i" :selectedPermissions="selectedPermissions" :expandedNodes="expandedNodes" @emitTree="handleTreeClick" @emitExpand="renderExpand"></PermissionNode>
  </section>
</article>
</template>

<script setup="true" name="RoleTree">
import { onMounted, ref } from "vue"
import PermissionNode from './PermissionNode.vue'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
})

const emit = defineEmits(['emitCheck'])

const expandedNodes = ref([]) // 展开 节点
const permissionsData = ref([]) // 权限 数据
const selectedPermissions = ref([]) // 选中 节点

onMounted(() => {

})
/**
 *@Description 展开 全部 .
 *@Return
**/
const handleExpandClick = () => {
  const addAllNodes = (ns) => {

    ns.forEach(n => {
      if (n.resourceType === 'MENU' && n.children) {
        if (!expandedNodes.value.includes(n.resourceId)) {
          expandedNodes.value.push(n.resourceId)
        }

        addAllNodes(n.children)
      }
    })
  }

  addAllNodes(permissionsData.value)
}
/**
 *@Description 清空 选择 .
 *@Return
**/
const handleClearClick = () => {
  selectedPermissions.value.splice(0, selectedPermissions.value.length)
  emit('emitCheck', selectedPermissions.value)
}
/**
 *@Description 全选 选择 .
 *@Return
**/
const handleAllClick = () => {
  const allIds = []

  const collectSelectable = (ns) => {
    ns.forEach(n => {
      if (n.resourceType === 'MENU' || n.resourceType === 'PAGE') {
        allIds.push(n.resourceId);
      }

      if (n.children) {
        collectSelectable(n.children);
      }
    });
  };

  collectSelectable(permissionsData.value)
  selectedPermissions.value = [...allIds]

  emit('emitCheck', allIds)
}
/**
 *@Description 树 节点 点击 事件 .
 *@Return
**/
const handleTreeClick = (nId, n) => {
  const curSelect = selectedPermissions.value.includes(nId) // 当前节点是否被选中

  console.log('点击节点:', nId, n)

  if (n.resourceType === 'MENU') {
    if (curSelect) {
      const index = selectedPermissions.value.indexOf(nId)
      if (index > -1) selectedPermissions.value.splice(index, 1)

      const descendants = getAllDescendants(n)
      descendants.forEach(id => {
        const idx = selectedPermissions.value.indexOf(id)
        if (idx > -1) selectedPermissions.value.splice(idx, 1)
      })
      checkAndRemoveParentPermissions(nId)

    } else {
      selectedPermissions.value.push(nId)

      const ancestors = getAllAncestors(nId, permissionsData.value)
      ancestors.forEach(id => {
        if (!selectedPermissions.value.includes(id)) {
          selectedPermissions.value.push(id)
        }
      })

      if (n.children) {

        const pages = n.children.filter(child => child.resourceType === 'PAGE')
        const buttons = n.children.filter(child => child.resourceType === 'BTN')

        if (pages.length === 0 && buttons.length > 0) {
          // 问题1：如果没有页面只有按钮，选择所有按钮
          buttons.forEach(button => {
            if (!selectedPermissions.value.includes(button.resourceId)) {
              selectedPermissions.value.push(button.resourceId)
            }
          })
        }

        n.children.forEach(child => {
          if (child.resourceType === 'MENU' || child.resourceType === 'PAGE') {
            if (!selectedPermissions.value.includes(child.resourceId)) {
              selectedPermissions.value.push(child.resourceId)
            }

            if (child.resourceType === 'MENU') {
              const childDescendants = getAllDescendants(child)

              childDescendants.forEach(id => {
                const descendantNode = findNodeById(permissionsData.value, id)
                if (descendantNode && (descendantNode.resourceType === 'MENU' || descendantNode.resourceType === 'PAGE')) {
                  if (!selectedPermissions.value.includes(id)) {
                    selectedPermissions.value.push(id)
                  }
                }
              })
            }

          }
        })
      }

    }

  } else if (n.resourceType === 'PAGE') {

    if (curSelect) {
      const index = selectedPermissions.value.indexOf(nId)
      if (index > -1) selectedPermissions.value.splice(index, 1)
      // checkAndRemoveParentPermissions(nId)

    } else {
      selectedPermissions.value.push(nId)

      const ancestors = getAllAncestors(nId, permissionsData.value)
      ancestors.forEach(id => {
        if (!selectedPermissions.value.includes(id)) {
          selectedPermissions.value.push(id)
        }
      })

      const parent = getParentNode(permissionsData.value, nId)
      if (parent) {
        const bs = getChildrenOfType(parent, 'BTN')
        bs.forEach(bId => {
          const idx = selectedPermissions.value.indexOf(bId)
          if (idx > -1) selectedPermissions.value.splice(idx, 1)
        })
      }
    }

  } else if (n.resourceType === 'BTN') {
    const parent = getParentNode(permissionsData.value, nId)
    if (!parent) return

    // 获取同级的页面和按钮
    const siblingPages = parent.children.filter(child => child.resourceType === 'PAGE')
    const siblingButtons = parent.children.filter(child => child.resourceType === 'BTN')

    // 检查是否有同级页面被选中
    const hasSelectedPage = siblingPages.some(page => selectedPermissions.value.includes(page.resourceId))

    if(hasSelectedPage) {
      // 如果有页面被选中，点击按钮表示要取消隐式全选
      if (!curSelect) {
        // 取消所有同级页面的选择
        siblingPages.forEach(page => {
          const idx = selectedPermissions.value.indexOf(page.resourceId)
          if (idx > -1) selectedPermissions.value.splice(idx, 1)
        })

        // 将除了当前点击按钮外的其他同级按钮加入selectedPermissions
        siblingButtons.forEach(button => {
          if (button.resourceId !== nId && !selectedPermissions.value.includes(button.resourceId)) {
            selectedPermissions.value.push(button.resourceId)
          }
        })

        // 确保祖先菜单被选中
        const ancestors = getAllAncestors(nId, permissionsData.value)
        ancestors.forEach(id => {
          if (!selectedPermissions.value.includes(id)) {
            selectedPermissions.value.push(id)
          }
        })
      }
    } else {
      if (curSelect) {
        const index = selectedPermissions.value.indexOf(nId)
        if (index > -1) selectedPermissions.value.splice(index, 1)
        // checkAndRemoveParentPermissions(nId)

      } else {
        selectedPermissions.value.push(nId)

        const ancestors = getAllAncestors(nId, permissionsData.value)
        ancestors.forEach(id => {
          if (!selectedPermissions.value.includes(id)) {
            selectedPermissions.value.push(id)
          }
        })

        const parent = getParentNode(permissionsData.value, nId)
        if (parent) {
          const pages = getChildrenOfType(parent, 'PAGE')
          pages.forEach(pageId => {
            const idx = selectedPermissions.value.indexOf(pageId)
            if (idx > -1) selectedPermissions.value.splice(idx, 1)
          })
        }
      }
    }
  }

  emit('emitCheck', selectedPermissions.value)
}
/**
 *@Description 树 节点 展开 收起 .
 *@Return
**/
const renderExpand = (nId) => {
  const idx = expandedNodes.value.indexOf(nId)

  if (idx > -1) {
    expandedNodes.value.splice(idx, 1)
  } else {
    expandedNodes.value.push(nId)
  }
}
/**
 *@Description 选中 所有 子节点 .
 *@Return
**/
const getAllDescendants = (n) => {
  let arr = []

  if (n.children) {
    for (let i of n.children) {
      arr.push(i.resourceId)
      arr.push( ...getAllDescendants(i) )
    }
  }

  return arr
}
/**
 *@Description 选中/移除 选中的 父节点 .
 *@Return
**/
const checkAndRemoveParentPermissions = (nId) => {
  const parent = getParentNode(permissionsData.value, nId)
  if (!parent) return false

  const hasSelectedChild = parent.children.some(s => selectedPermissions.value.includes(s.resourceId) )

  if (!hasSelectedChild) {
    const idx = selectedPermissions.value.indexOf(parent.resourceId)
    if (idx > -1) selectedPermissions.value.splice(idx, 1)

    checkAndRemoveParentPermissions(parent.resourceId)
  }
}
/**
 *@Description 子节点 查 父节点 .
 *@Return
**/
const getParentNode = (data, childId) => {
  const findParent = (ns, targetId) => {

    for (let n of ns) {
      if (n.children) {
        for (let child of n.children) {
          if (child.resourceId === targetId) return n
        }

        let found = findParent(n.children, targetId)
        if (found) return found
      }
    }

    return null
  }

  return findParent(data, childId)
}
/**
 *@Description id 查 节点 .
 *@Return
**/
const findNodeById = (data, id) => {
  for (let n of data) {
    if (n.resourceId === id) return n

    if (n.children) {
      let found = findNodeById(n.children, id)
      if (found) return found
    }
  }

  return null
}
/**
 *@Description 获取 所有 父节点 .
 *@Return
**/
const getAllAncestors = (nId, data) => {
  let ancestors = []

  const findAncestors = (ns, targetId, currentPath = []) => {
    for (let n of ns) {
      let newPath = [...currentPath, n.resourceId]

      if (n.resourceId === targetId) {
        ancestors = currentPath
        return true
      }

      if (n.children && findAncestors(n.children, targetId, newPath)) {
        return true
      }
    }

    return false
  }

  findAncestors(data, nId)

  return ancestors
}
/**
 *@Description 匹配 类型 节点 id .
 *@Return
**/
const getChildrenOfType = (n, type) => {
  if (!n.children) return []
  return n.children.filter(f => f.resourceType === type).map(m => m.resourceId)
}

/** 父组件调用 **/
/**
 *@Description 抛出 内部方法 父组件 使用  设置数据源 .
 *@Return
**/
const setBoxData = (d, arr = []) => {
  console.log('ro ot 数据：',  d, arr)
  permissionsData.value = d.resources
  // 默认展开第一级菜单
  d.resources.forEach(n => {
    if (n.resourceType === 'MENU') {
      expandedNodes.value.push(n.resourceId)
    }
  })

  if(arr.length > 0) {
    selectedPermissions.value = [ ...arr ]
  }
}

defineExpose({ setBoxData })
</script>

<style lang="scss" scoped>
@import "@/style/const";
@import "@/style/mixins";
$_row-height: 54px;
$_cell-width: 157px;
$_border-color: #E4E8F6;

.no-box {
  height: 100%;
}
.he-ad {
  align-items: center;
  height: $_row-height;
  background-color: #EBF0FA;
  border: 1px solid $_border-color;

  /* 操作按钮 */
  .ac-btn {
    padding-right: 20px;
    margin-left: auto;
  }
}
// 树
.tr-ee {
  padding: 16px;
  overflow-y: auto;
  box-sizing: border-box;
  max-height: calc(100% - #{$_row-height});
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-left: 1px solid $_border-color;
  border-right: 1px solid $_border-color;
}
</style>
